import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Configurations } from '../shared/configurations.model';
import { ConfigurationsService } from '../shared/configurations.service';
export enum CONFIGURATIONS_ACTION {
  DEFAULT,
  ADD,
  EDIT
}

@Component({
  selector: 'app-configurations-detail',
  templateUrl: './configurations-detail.component.html',
  styleUrls: ['./configurations-detail.component.scss']
})

export class ConfigurationsDetailComponent implements OnInit {
  public data: Configurations;
  public isLoading = false;
  public isSave = false;
  public isAdd = false;
  public jsonView = false;
  public mode: CONFIGURATIONS_ACTION = CONFIGURATIONS_ACTION.DEFAULT;
  public modeCheck: any = CONFIGURATIONS_ACTION;

  private handleParams$ = this.route.params
    .map(params => params['id'])
    .do(() => {
      this.isSave = false;
      this.isAdd = false;
      this.mode = CONFIGURATIONS_ACTION.DEFAULT;
      this.data = null;
    })
    .filter(id => !!id)
    .map(id => {
      this.isLoading = true;
      this.configurationsService.get(id).subscribe(
        res => {
          this.data = res;
          setTimeout(() => {
            this.isLoading = false;
          }, 300);
        },
        error => {
          this.isLoading = false;
        }
      );
    });

  constructor(private route: ActivatedRoute, private configurationsService: ConfigurationsService) { }

  ngOnInit() {
    this.handleParams$.subscribe();
  }

  viewJson() {
    this.jsonView = !this.jsonView;
  }

  cancel() {
    this.mode = CONFIGURATIONS_ACTION.DEFAULT;
    this.handleParams$.subscribe();
  }
  save(event?) {
    this.isSave = true;
    this.configurationsService.updateConfigById(this.data.id, this.data).subscribe(
      () => {
        setTimeout(() => {
          this.isSave = false;
          this.mode = CONFIGURATIONS_ACTION.DEFAULT;
        }, 300);
      },
      error => { }
    );
  }

  add(event?) {
    this.isAdd = true;
    this.configurationsService.updateConfigById(this.data.id, this.data).subscribe(
      () => {
        setTimeout(() => {
          this.isAdd = false;
        }, 300);
      },
      error => { }
    );
  }

}



// WEBPACK FOOTER //
// /ng-app/src/app/configurations/configurations-detail/configurations-detail.component.ts